import { OrderOutput, PropertyData, UserData } from 'frontend.client.api';
import { ApiService } from '../../shared/api.service';
import { PartnerStateService } from '../../shared/partner-state.service';
import { RouterService } from '../../shared/router.service';
import { ThresholdService } from '../../shared/threshold.service';
import { AccessHashService } from '../access-hash.service';
import { OrderServiceState } from './order.service.state';

export class OrderServiceUtils extends OrderServiceState {
  constructor(
    protected apiService: ApiService,
    protected partnerStateService: PartnerStateService,
    protected router: RouterService,
    protected accessHashService: AccessHashService,
    protected thresholdService: ThresholdService,
  ) {
    super();
  }

  protected patchPropertyData = (
    current?: PropertyData,
    update?: PropertyData,
  ): PropertyData => {
    if (current || update) {
      return {
        ...current,
        ...update,
        owner: {
          ...current?.owner,
          ...update?.owner,
        },
        propertyAddress: {
          ...current?.propertyAddress,
          ...update?.propertyAddress,
        },
        userIsOwner: update?.userIsOwner ?? current?.userIsOwner,
      };
    }
    return {};
  };

  protected patchUserData = (
    current?: UserData,
    update?: UserData,
  ): UserData | undefined => {
    if (current || update) {
      return {
        ...current,
        ...update,
        email: update?.email ?? current?.email ?? '',
      };
    }
    return;
  };

  public handleUpdatedOrderOutput(orderOutput?: OrderOutput) {
    this.accessHashService.setBirthday(
      orderOutput?.userData?.userPersonalData?.birthday,
    );
    this.orderState$.next({
      isLoading: false,
      order: orderOutput,
      error: undefined,
    });
  }
}
